import { ThemeProvider } from '@mui/material/styles';
import NavbarStyle from './NavbarStyle';
import { navbarTheme } from '../styles/defaultTheme';

const NavbarWrapperLayout = () => {
  return (
    <ThemeProvider theme={navbarTheme}>
      <NavbarStyle />
    </ThemeProvider>
  );
};

export default NavbarWrapperLayout;
